/* eslint-disable camelcase */
import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'src/api/axiosBaseQuery'
import { API_BASE_PATH } from 'src/utils/constants'
import {
  PaginationPayload,
  BranchGymDetailsResponse,
  BranchGymsListResponse,
  UpdateBranchGymPayload,
} from './types'

const API_ENDPOINT = '/api/v1/fitness'

const manageBranchGymsApi = createApi({
  reducerPath: 'manageBranchGymsApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosBaseQuery({
    baseUrl: API_BASE_PATH,
  }),
  tagTypes: ['manageBranchGymsApi'],
  endpoints: (builder) => ({
    getBranchGymsList: builder.query<BranchGymsListResponse, PaginationPayload>({
      query: ({ page = 1, pageSize = 10, sortBy = '', search = '' }) => ({
        url: `${API_ENDPOINT}/admin_gym/?q=${search}&page=${page}&page_size=${pageSize}${
          sortBy ? `&sort_by=${sortBy}` : ''
        }`,
        method: 'GET',
      }),
      transformResponse: (response: BranchGymsListResponse) => {
        return response
      },
    }),

    getBranchGymById: builder.query<BranchGymDetailsResponse, number>({
      query: (id) => ({
        url: `${API_ENDPOINT}/admin_gym/${id}/`,
        method: 'GET',
      }),
      transformResponse: (response: BranchGymDetailsResponse) => {
        return response
      },
    }),

    addBranchGym: builder.mutation<void, FormData>({
      query: (data) => ({
        url: `${API_ENDPOINT}/admin_gym/`,
        method: 'POST',
        data: data,
      }),
    }),

    deleteBranchGym: builder.mutation<void, number>({
      query: (id) => ({
        url: `${API_ENDPOINT}/admin_gym/${id}/`,
        method: 'DELETE',
      }),
    }),

    updateBranchGym: builder.mutation<void, UpdateBranchGymPayload>({
      query: ({ data, id }) => ({
        url: `${API_ENDPOINT}/admin_gym/${id}/`,
        method: 'PATCH',
        data: data,
      }),
    }),
  }),
})

export const {
  useGetBranchGymsListQuery,
  useAddBranchGymMutation,
  useDeleteBranchGymMutation,
  useGetBranchGymByIdQuery,
  useUpdateBranchGymMutation,
} = manageBranchGymsApi
export default manageBranchGymsApi
